// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"479":"4eb287b2","539":"707413d8","932":"48962926"}[chunkId] + ".chunk.js";
};